const t = {
  name: "Document1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 21C21 22.6569 19.6569 24 18 24H6C4.34315 24 3 22.6569 3 21V3C3 1.34314 4.34315 0 6 0H14.4142L21 6.58579V21ZM5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V9H15C13.3431 9 12 7.65685 12 6V2H6C5.44771 2 5 2.44772 5 3ZM14 2.41421V6C14 6.55228 14.4477 7 15 7H18.5858L14 2.41421Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Document1
};
